import React, { useState } from "react";
import { defaultStyles } from "../../../constants/style-constants/utils";
// import Modal from "./Modal";
import { Button } from "../../../components/styled-components/button";
import fileIcon from "../../../assets/images/DeathModuleNew/Icons.png";

import * as Style from "../styles/ModalStyle";
import { Icon, Modal, Select, Row, Col, Radio, Input } from "antd";
import Currency from "../../../components/form/Currency";
import { InputGroup } from "../../../components/inputGroup/InputGroup";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import PhoneNum from "../../../components/form/components/Countrycode";
import TextArea from "antd/lib/input/TextArea";
import WebAddress from "../../../components/form/WebAddress";
import swal from "sweetalert";
import { DatePicker } from "antd";
import DEATH_API from "../../../apis/death.api";
const { Option } = Select;

function AddFuneralModal({
  show,
  close,
  fields,
  submitData,
  modalTitle,
  handlechange,
  handleDocumentChange,
  handleDatePickerChange,
  handleRadioChange,
  handlePhoneChange,
  handleSelectChange,
  role,
}) {
  const { styles } = defaultStyles;
  const [formData, setFormData] = useState({});
  const [textField, setTextField] = useState(false);
  const [cermation, setCermation] = useState(false);
  const [otherPreference, setOtherPreference] = useState(false);

  const [burial, setburial] = useState(false);
  const [scattering, setScattering] = useState(false);
  const [showFields, setShowFields] = useState({});

  const [loading, setLoading] = useState(false);
  const [templateDesign, setTemplateDesign] = useState("");
  console.log(fields, "fields newww");
  const [selectListCustomtext, setselectListCustomtext] = useState({});
  const handleSubmit = () => {
    submitData();
    setShowFields({});
    close();
  };
 
  console.log("show....", show);

  for (let i = 0; i < fields.length; i++) {
    console.log("fieldssssss", fields[i]);
  }
  return (
    <Modal footer={null} closable={false} visible={show} centered>
      {console.log("show in modal", show)}
      <Style.HeaderConatiner>
        <Style.ModalTitle> {modalTitle}</Style.ModalTitle>
        {/* <Icon type="close" onClick={close}></Icon> */}
      </Style.HeaderConatiner>

      <div
        style={{
          marginTop: "1rem",
          maxHeight: "25rem",
          overflow: "scroll",
          padding: "1rem",
        }}
      >
        {fields.map((item, idx) => {
          const {
            title,
            type,
            options = [],
            index = null,
            isRequired = false,
            def = null,
            isDisabled = false,
          } = item;
          switch (type) {
            case "email":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Style.Input
                    defaultValue={def}
                    disabled={role==="protrustee" ? true :false}
                    name={item.title}
                    onChange={(e) => {
                      e.preventDefault();
                      handlechange(e);
                    }}
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></Style.Input>
                </div>
              );
            case "input":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  {title === "2FA" ? (
                    <Style.Input
                      // defaultValue={def}
                      disabled={role==="protrustee" ? true :false}
                      value={null}
                      name={index}
                      // name={item.title}
                      onChange={(e) => {
                        e.preventDefault();
                        handlechange(e);
                      }}
                      size="large"
                      placeholder={`Google Auth, YubiKey, SMS/Text, etc.`}
                      // name="client_primaryContactNumber"
                    ></Style.Input>
                  ) : (
                    <Style.Input
                      // defaultValue={def}
                      disabled={role==="protrustee" ? (item.title ==="Preferred Funeral Home/Mortuary" || item.title ==="Address" || item.title ==="Phone Number" ) ? false : true :false}
                      value={null}
                      name={index}
                      // name={item.title}
                      onChange={(e) => {
                        e.preventDefault();
                        handlechange(e);
                      }}
                      size="large"
                      placeholder={`Enter ${title}`}
                      // name="client_primaryContactNumber"
                    ></Style.Input>
                  )}
                </div>
              );
            case "emails":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Style.Input
                    // className="custom-input"
                    disabled={role==="protrustee" ? true :false}
                    defaultValue={def}
                    name={index}
                    onChange={(e) => {
                      e.preventDefault();
                      handlechange(e);
                    }}
                    
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></Style.Input>
                </div>
              );
            case "Title":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                 
                </div>
              );
            case "phoneNumber":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <PhoneNum
                    defaultValue={def}
                    name={index}
                    onChange={(e) => {
                      // handlechange(e);
                      handlePhoneChange(index, e.target.value);
                    }}
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></PhoneNum>
                </div>
              );
            case "phoneNumberA":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <PhoneNum
                    defaultValue={def}
                    name={index}
                    onChange={(e) => {
                      handlePhoneChange(index, e.target.value);

                      // handlechange(e);
                    }}
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></PhoneNum>
                </div>
              );
            case "currency":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Currency
                    id={index}
                    value={null}
                    disabled={role==="protrustee" ? true :false}
                    placeholder={`Enter ${title}`}
                    name={index}
                    onChange={(event) => {
                      event.preventDefault();

                      handlechange(event);
                    }}
                  ></Currency>
                </div>
              );
           
            case "select":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {console.log("index", index)}
                  <Select
                    showSearch
                    disabled={role==="protrustee" ? true :false}
                    placeholder={item.title}
                    name={index}
                    onChange={(value, id) => {
                      console.log("value", value);
                      if (value) {
                        handleSelectChange(index, value);
                        if (value === "Burial") {
                          setburial(true);
                          setCermation(false);
                        }
                        if (value === "Cremation") {
                          console.log("value", value);
                          setCermation(true);
                          setburial(false);
                        }
                        // if (value === "Others") {
                        //   // this.setState({textField:true});
                        //   this.setState({
                        //     selectListCustomtext: {
                        //       ...this.state.selectListCustomtext,
                        //       [index]: true,
                        //     },
                        //   });
                        //   // console.log("other is selected..",this.state.textField);
                        // }
                        else {
                          setFormData({
                            [index]: value,
                          });
                        }
                      } else {
                        setFormData({
                          ["TemplateID"]: id.key,
                        });
                      }
                    }}
                  >
                    {index === "TextTemplates" &&
                      // console.log("options text", options)

                      options &&
                      options.map((item, index) => {
                        return (
                          <Option key={item.id} value={item.name}>
                            {item.name}
                          </Option>
                        );
                      })}
                    {index === "Templates" &&
                      // console.log("options email", options)
                      options &&
                      options.map((item, index) => {
                        return (
                          <Option key={item.id} value={item.name}>
                            {item.name}
                          </Option>
                        );
                      })}
                    {index !== "Templates" &&
                      index !== "TextTemplates" &&
                      // console.log("options", options)
                      options &&
                      options.map((item, index) => {
                        return (
                          <Option key={index} value={item}>
                            {item}
                          </Option>
                        );
                      })}
                  </Select>

                  {burial && (
                    <div style={{ marginTop: "8px" }}>
                      <Radio.Group
                        onChange={(e) => {
                          handleRadioChange("burial", e.target.value);
                        }}
                      >
                        {[
                          "Ground Burial",
                          "Mausoleum",
                          "Above-ground Crypt",
                        ].map((value, vindex) => (
                          <Radio.Button key={vindex} value={value}>
                            {value}
                          </Radio.Button>
                        ))}
                      </Radio.Group>
                    </div>
                  )}
                  {cermation && (
                    <div style={{ marginTop: "8px" }}>
                      <Radio.Group
                        onChange={(e) => {
                          console.log("value radio", e.target.value);
                          handleRadioChange("cremation", e.target.value);
                          if (e.target.value === "Scattering") {
                            setScattering(true);
                          }
                          else{
                            setScattering(false);
                          }
                        }}
                      >
                        {[
                          "Ground Cremation",
                          "Mausoleum",
                          "Cremation Garden",
                          "Scattering",
                        ].map((value, vindex) => (
                          <Radio.Button key={vindex} value={value}>
                            {value}
                          </Radio.Button>
                        ))}
                      </Radio.Group>
                    </div>
                  )}
                  {scattering && (
                    <div style={{ marginTop: "8px" }}>
                      <Style.Input
                        disabled={isDisabled}
                        value={null}
                        name="scatteringLocation"
                        // name={item.title}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e);
                        }}
                        size="large"
                        placeholder={`Enter ${title}`}
                      ></Style.Input>
                    </div>
                  )}
                  {selectListCustomtext && selectListCustomtext[index] && (
                    <div className="custom-field-align">
                      <Input
                        id={`section${index}`}
                        name={title}
                        type="text"
                        placeholder={`Enter ${title}`}
                        size={"large"}
                        onChange={(e) => {
                          // console.log("value....", e.target.value)
                        }}
                      />
                      <Button
                        className="button-set"
                        onClick={() => {
                          const value = document.getElementById(
                            `section${index}`
                          ).value;
                          setFormData({
                            [index]: value,
                          });
                          setselectListCustomtext((prevFormData) => ({
                            ...prevFormData,
                            [index]: false,
                          }));
                          // this.setState({
                          //   selectListCustomtext: {
                          //     ...this.state.selectListCustomtext,
                          //     [index]: false,
                          //   },
                          // });
                        }}
                      >
                        OK
                      </Button>{" "}
                    </div>
                  )}

                  {}
                  {/*      {this.state.textField && <div className="custom-field-align">

                        <Input
                          // id="section"
                          id={`section${index}`}
                          // className="field-set"
                          name={title}
                          type="text"
                          placeholder={`Enter ${title}`}
                          size={"large"}
                          onChange={(e) => {
                            // console.log("value....", e.target.value)
                          }}
                        />
                        <Button
                          className="button-set"
                          onClick={() => {
                            const value = document.getElementById(`section${index}`).value;
                            console.log("value.. saved", value);
                            setFormData({
                              [index]: value,
                            });
                            this.setState({textField:false});
                          }

                          }
                        >
                          OK
                        </Button>{" "}
                        </div>}  */}
                </div>
              );

            case "date":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <DatePicker
                    size="large"
                    // style={{ width: "100%" }}
                    disabled={role==="protrustee" ? true :false}
                    format={"MM/DD/YYYY"}
                    name={item.title}
                    onChange={(date, dateString) => {
                      handleDatePickerChange(item.title, dateString);
                      setFormData({
                        [index]: dateString,
                      });
                    }}
                  />
                </div>
              );

            case "textarea":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <TextArea
                    id={index}
                    placeholder={`Enter ${title}`}
                    name={index}
                    onChange={handlechange}
                    disabled={role==="protrustee" ? true :false}
                    
                  />
                </div>
              );


            case "radio":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Radio.Group
                  disabled={role==="protrustee" ? true :false}
                    onChange={(e) => {
                      handleRadioChange(index, e.target.value);
                      if(e.target.value==="Return To" ){
                        setShowFields({
                          ...showFields,
                          [index]: true,
                        });
                      }
                      else if(e.target.value==="Other"){
                        setOtherPreference(true);
                      }
                      else{
                        setShowFields({
                          ...showFields,
                          [index]: false,
                        });
                        setOtherPreference(false);
                      }
                    }}
                  >
                    {options.map((value, vindex) => (
                      <Radio.Button key={vindex} value={value}>
                        {value}
                      </Radio.Button>
                    ))}
                  </Radio.Group>

                  {otherPreference && (
                    <div style={{ marginTop: "8px" }}>
                      <Style.Input
                        disabled={isDisabled}
                        value={null}
                        name="otherPreference"
                        // name={item.title}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e);
                        }}
                        size="large"
                        placeholder={`Enter ${title}`}
                      ></Style.Input>
                    </div>
                  )}

                  {showFields[index] && (
                    <div style={{ marginTop: "8px" }}>
                      <Style.Input
                        disabled={isDisabled}
                        value={null}
                        name={`${index}ReturnTo`}
                        // name={item.title}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e);
                        }}
                        size="large"
                        placeholder={`Enter ${title}`}
                      ></Style.Input>
                    </div>
                  )}

                </div>
              );

         
            
          }
        })}
      </div>

      <Style.WrapperButtons>
        <Style.CancelButton onClick={close}>Cancel</Style.CancelButton>
        <Style.SaveButton onClick={handleSubmit}>Save</Style.SaveButton>
      </Style.WrapperButtons>
    </Modal>
  );
}

export default AddFuneralModal;
